import React from "react";
import { NavLink } from "react-router-dom";
import { setBlurOff, setNavOff } from "../../store/slices/hostSlices";
import { useDispatch, useSelector } from "react-redux";
import { getFlags } from "../../store/thunks/hostActions";

const SideNavLink = ({ icon, label, link, active }) => {
    const {hostInfo} = useSelector((state) => {
        return state.host;
    });

    const dispatch = useDispatch();

    return (
        <NavLink
            to={`/${link}`}
            onClick={(e) => {
                dispatch(setNavOff())
                dispatch(setBlurOff())
                dispatch(getFlags(hostInfo._id));
            }}
            className={({ isActive }) => 
                `flex items-center gap-3 px-4 py-3 mx-2 rounded-xl transition-all duration-200 group ${
                    isActive 
                        ? 'bg-gray-100 text-gray-900' 
                        : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
                }`
            }
        >
            {({ isActive }) => (
                <>
                    <div className={`p-2 rounded-lg transition-all duration-200 ${
                        isActive
                            ? 'bg-gray-200'
                            : 'bg-gray-100 group-hover:bg-gray-200'
                    }`}>
                        <img
                            src={icon}
                            alt={`${label} icon`}
                            className={`w-5 h-5 ${isActive ? 'opacity-100' : 'opacity-50 group-hover:opacity-80'}`}
                        />
                    </div>
                    <span className="font-medium text-sm">{label}</span>
                </>
            )}
        </NavLink>
    );
};

export default SideNavLink;
